/**
 * Query Key factory for all promo code queries.
 *
 * @module PromoCode
 */

import { Pagination } from "@customTypes/index";


export const promoCodeQKeys = {
  all: () => ["promoCodes"] as const,

  allWithFilters: (filters?: {
    pagination?: Partial<Pagination>;
    search?: string;
    activeOnly?: boolean;
    service?: string;
    medicalProfessional?: string;
  }) => [...promoCodeQKeys.all(), { ...filters }] as const,
};
